/**
 * Global definitions that need to be available before any Vue components are loaded.
 * This file must be imported FIRST in app.js, before routes or any component imports.
 */

import Form from './utils/Form';
import Modal from './utils/Modal';
import AxiosError from './utils/AxiosError';
import AccountTypes from './utils/AccountTypes';
import DownloadFile from './utils/DownloadFile';
// Global utilities (for legacy code compatibility)
window.Form = Form;
window.Modal = Modal;
window.AxiosError = AxiosError;
window.AccountTypes = AccountTypes;
window.DownloadFile = DownloadFile;

// Default app title
window.AppTitle = document.title;

// Define Api entries
window.Api = '/api';

// Query param helper
window.getQueryParam = function (param) {
    let found;
    window.location.search
        .substring(1)
        .split('&')
        .forEach(function (item) {
            if (param === item.split('=')[0]) {
                found = item.split('=')[1];
            }
        });
    return found ? decodeURIComponent(found) : undefined;
};

// Chrome detection for CSS
if (typeof navigator !== 'undefined' && /chrome/i.test(navigator.userAgent)) {
    document.body.className += ' chrome';
}
